import { Partial } from '@40seas/entities/common';
import { CreditSafePortfolioCompany } from './credit-safe.portfolio.company.entity';

export class UpdateCreditSafePortfolioCompanyDto extends Partial(CreditSafePortfolioCompany) {}
